import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // To redirect after success
import { BASE_URL } from '../config/api'; // Make sure this is set correctly

const AddBrandWise = () => {
  const [formData, setFormData] = useState({
    description: '',
    date: '',
    sno: '',
    brand_code: '',
    brand_name: '',
    retailer_discount: '',
    wholesaler_discount: '',
    dealer_discount: ''
  });

  const navigate = useNavigate();

  // Handle input field changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Show the payload in the console for debugging purposes
      console.log('Payload:', formData);

      // Send POST request to the API
      const response = await fetch(`${BASE_URL}brandwise`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      console.log('API Response:', data); // For debugging

      if (data.status === 'success') {
        alert('Brand-wise discount added successfully!');
        navigate('/BrandWiseList'); // Redirect to the list page
      } else {
        alert('Failed to add brand-wise details.');
      }
    } catch (error) {
      console.error('Error adding brand-wise details:', error);
      alert('An error occurred while adding the brand-wise details.');
    }
  };

  return (
    <div id="main">
      <header className="mb-3">
        <a href="#" className="burger-btn d-block d-xl-none">
          <i className="bi bi-justify fs-3"></i>
        </a>
      </header>

      <div className="page-heading">
        <h3>Add Brand-Wise Discount</h3>
      </div>

      <section className="section">
        <div className="card">
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label htmlFor="description" className="form-label">Description</label>
                <input
                  type="text"
                  id="description"
                  name="description"
                  className="form-control"
                  value={formData.description}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="date" className="form-label">Date</label>
                <input
                  type="date"
                  id="date"
                  name="date"
                  className="form-control"
                  value={formData.date}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="sno" className="form-label">Serial Number</label>
                <input
                  type="number"
                  id="sno"
                  name="sno"
                  className="form-control"
                  value={formData.sno}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="brand_code" className="form-label">Brand Code</label>
                <input
                  type="text"
                  id="brand_code"
                  name="brand_code"
                  className="form-control"
                  value={formData.brand_code}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="brand_name" className="form-label">Brand Name</label>
                <input
                  type="text"
                  id="brand_name"
                  name="brand_name"
                  className="form-control"
                  value={formData.brand_name}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="retailer_discount" className="form-label">Retailer Discount (%)</label>
                <input
                  type="number"
                  id="retailer_discount"
                  name="retailer_discount"
                  className="form-control"
                  value={formData.retailer_discount}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="wholesaler_discount" className="form-label">Wholesaler Discount (%)</label>
                <input
                  type="number"
                  id="wholesaler_discount"
                  name="wholesaler_discount"
                  className="form-control"
                  value={formData.wholesaler_discount}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="dealer_discount" className="form-label">Dealer Discount (%)</label>
                <input
                  type="number"
                  id="dealer_discount"
                  name="dealer_discount"
                  className="form-control"
                  value={formData.dealer_discount}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <button type="submit" className="btn btn-primary">Add Brand-Wise Discount</button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AddBrandWise;
